export default __webpack_public_path__ + "static/media/first-left-img-2x.a356ac92.png";